import React, { useState} from "react";
import { TabsContent } from "../ui/tabs";
import AISummary from "./cards/AISummary";
import NetworkStats from "./cards/NetworkStats";
import DeviceStatus from "./cards/DeviceStatus";
import NetworkMap from "./cards/NetworkMap";
import ApplicationStatus from "./cards/ApplicationStatus";
import RecentIssues from "./cards/RecentIssues";
import TestSlideout from "./TestSlideout";
import IssueSlideout from "./IssueSlideout";

const SummaryTabContent = ({ userId }) => {
  const [isTestSlideoutOpen, setIsTestSlideoutOpen] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);

  const [isIssueSlideoutOpen, setIsIssueSlideoutOpen] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState(null);

  const handleOpenTestSlideout = (testId) => {
    setSelectedTest(testId);
    setIsIssueSlideoutOpen(false);
    setIsTestSlideoutOpen(true);
  }

  const handleCloseTestSlideout = () => {
    setSelectedTest(null);
    setIsTestSlideoutOpen(false);
  };

  const handleOpenIssueSlideout = (issueId) => {
    setSelectedIssue(issueId);
    setIsTestSlideoutOpen(false);
    setIsIssueSlideoutOpen(true);
  };

  const handleCloseIssueSlideout = () => {
    setSelectedIssue(null);
    setIsIssueSlideoutOpen(false);
  };

  return (
    <TabsContent value="summary" className="space-y-6">
      {/* AI Summary - above Recent Issues */}
      <AISummary />
      
      {/* Recent Issues */}
      <RecentIssues onRowClick={handleOpenIssueSlideout} />
      
      {/* Network Stats and Device Status side by side */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <NetworkStats />
        </div>
        <div className="space-y-2">
          <DeviceStatus />
        </div>
      </div>

      {/* Network Map */}
      <NetworkMap userId={userId} onMarkerClick={handleOpenTestSlideout}/>

      {/* Application Status */}
      <ApplicationStatus />

      {/* Test Slideout */}
      <TestSlideout
        isOpen={isTestSlideoutOpen}
        testId={selectedTest}
        onClose={handleCloseTestSlideout}
      />

      {/* Issue Slideout */}
      <IssueSlideout 
        isOpen={isIssueSlideoutOpen} 
        issueId={selectedIssue} 
        onClose={handleCloseIssueSlideout}
      />

    </TabsContent>
  );
};

export default SummaryTabContent;
